import { Collapse } from "@mui/material";
import { FaAngleDown, FaAngleLeft } from "react-icons/fa";
import { useContext, useState } from "react";
import { SideBarItem } from "types/sideBarItem/SideBarItemType";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { UserContext } from "context/UserContext";

interface MultiploItemProps {
  item: SideBarItem;
  navigate: Function;
  idItemAtivo: number | undefined;
  changeIdItemAtivo: Function;
}

const MultiploItem: React.FC<MultiploItemProps> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const { usuarioPossuiAcessoTela } = usePermissoesContext();
  const { usuarioLogado } = useContext(UserContext);

  const toggleSubMenu = (idItem: number) => {
    if (idItem === props.idItemAtivo) {
      setOpen(false);
      props.changeIdItemAtivo(undefined);
    } else {
      setOpen(true);
      props.changeIdItemAtivo(idItem);
    }
  };

  const renderItemPrincpal = () => {
    const isItemAtivo = open && props.item.id === props.idItemAtivo;
    return (
      <div onClick={() => toggleSubMenu(props.item.id)}>
        <div className={`d-flex justify-content-between ${isItemAtivo ? "menu-item-aberto" : "menu-item"}`}>
          <div>
            <span>{props.item.icone}</span>
            <span>
              <span className="menu-item-title">{props.item.titulo}</span>
            </span>
          </div>
          <div>{isItemAtivo ? <FaAngleDown /> : <FaAngleLeft />}</div>
        </div>
      </div>
    );
  };

  const renderSubItems = () => {
    if (props.item.subitem) {
      let subItens = props.item?.subitem.filter((subItem) => {
        if (subItem.permissoes) {
          return usuarioPossuiAcessoTela(subItem.permissoes);
        }
        return true;
      });

      if (usuarioLogado.isContextoAdministradora) {
        subItens = subItens.filter((item) => item.isContextoGlobal);
      }

      return (
        <Collapse in={open && props.item.id === props.idItemAtivo} timeout="auto" unmountOnExit>
          <div
            className={`d-flex justify-content-between ${open ? "menu-item-aberto" : "menu-item"}`}
            style={{ padding: "0px 17px" }}
          >
            <div>
              {subItens.map((element, i) => (
                <div
                  key={element.id}
                  className={`d-flex justify-content-between menu-sub-item`}
                  onClick={() => props.navigate(element.rota, element.isV1)}
                >
                  <div>
                    {element.icone}&nbsp;
                    {element.titulo}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Collapse>
      );
    }
  };

  return (
    <div className={`menu-item p-0`}>
      {renderItemPrincpal()}
      {renderSubItems()}
    </div>
  );
};

export default MultiploItem;
